import { Plus } from 'lucide-react';

export function IconButton({ icon: Icon, label, onClick }) {
  return (
    <button className="icon-button" onClick={onClick} type="button" aria-label={label} title={label}>
      <Icon size={16} />
    </button>
  );
}

export function NavButton({ icon: Icon, label, value, activeView, setActiveView }) {
  return (
    <button
      className={activeView === value ? 'nav-button active' : 'nav-button'}
      onClick={() => setActiveView(value)}
      type="button"
    >
      <Icon size={18} />
      <span>{label}</span>
    </button>
  );
}

export function Composer({ icon: Icon, value, placeholder, onChange, onAdd }) {
  return (
    <section className="composer">
      <Icon size={18} />
      <input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => event.key === 'Enter' && onAdd()}
        placeholder={placeholder}
      />
      <button className="primary-button" onClick={onAdd} type="button"><Plus size={16} /> Add</button>
    </section>
  );
}

export function Metric({ icon: Icon, label, value }) {
  return (
    <div className="metric-card">
      <Icon size={20} />
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

export function Progress({ label, value, max }) {
  const percent = max ? Math.min((value / max) * 100, 100) : 0;
  return (
    <div className="progress-block">
      <div>
        <span>{label}</span>
        <strong>${Number(value).toFixed(0)} / ${Number(max).toFixed(0)}</strong>
      </div>
      <div className="progress-track"><span style={{ width: `${percent}%` }} /></div>
    </div>
  );
}
